// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"02615507","128":"249e02fd","204":"84219808","344":"e85ae380","352":"441924fd"}[chunkId] + ".chunk.js";
};